import Competence from './Competence';

export default Competence;
